import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { b2CConfig } from './config/B2CConfig';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const msalInstance = new PublicClientApplication(b2CConfig);
root.render(
    <React.StrictMode>
        <App instance={msalInstance} />
    </React.StrictMode>
);

reportWebVitals();
